/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { type PropertyAvailability, PropertyAvailabilityFromJSONTyped, PropertyAvailabilityToJSON, PropertyAvailabilityToJSONTyped } from './PropertyAvailability';
import { type PropertyUnavailability, PropertyUnavailabilityFromJSONTyped, PropertyUnavailabilityToJSON, PropertyUnavailabilityToJSONTyped } from './PropertyUnavailability';
/**
 * 
 * @export
 * @interface Property
 */
export interface Property {
    /**
     * Expedia property ID.
     * @type {string}
     * @memberof Property
     */
    propertyId?: string;
    /**
     * Helps determine which type of property response is returned.
     * @type {string}
     * @memberof Property
     */
    status?: PropertyStatusEnum;
    /**
     * A score to sort properties where the higher the value the better. It can be used to:<br> * Sort the properties on the response<br> * Sort properties across multiple responses in parallel searches for large regions<br>
     * @type {number}
     * @memberof Property
     */
    score?: number;
}


/**
 * @export
 */
export const PropertyStatusEnum = {
    Available: 'available',
    PartiallyUnavailable: 'partially_unavailable'
} as const;
export type PropertyStatusEnum = typeof PropertyStatusEnum[keyof typeof PropertyStatusEnum];


/**
 * Check if a given object implements the Property interface.
 */
export function instanceOfProperty(value: object): value is Property {
    return true;
}

export function PropertyFromJSON(json: any): Property {
    return PropertyFromJSONTyped(json, false);
}

export function PropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Property {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['status'] === 'available') {
            return PropertyAvailabilityFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['status'] === 'partially_unavailable') {
            return PropertyUnavailabilityFromJSONTyped(json, ignoreDiscriminator);
        }

    }
    return {
        
        'propertyId': json['property_id'] == null ? undefined : json['property_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'score': json['score'] == null ? undefined : json['score'],
    };
}

export function PropertyToJSON(json: any): Property {
    return PropertyToJSONTyped(json, false);
}

export function PropertyToJSONTyped(value?: Property | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (!ignoreDiscriminator) {
        switch (value['status']) {
            case 'available':
                return PropertyAvailabilityToJSONTyped(value as PropertyAvailability, ignoreDiscriminator);
            case 'partially_unavailable':
                return PropertyUnavailabilityToJSONTyped(value as PropertyUnavailability, ignoreDiscriminator);
            default:
                return value;
        }
    }

    return {
        
        'property_id': value['propertyId'],
        'status': value['status'],
        'score': value['score'],
    };
}

